// extracted by mini-css-extract-plugin
export var About = "style-module--About--dc1bc";
export var Description = "style-module--Description--6acc8";
export var Image = "style-module--Image--134c7";
export var ImageWrapper = "style-module--ImageWrapper--82b44";